// Client logos (optimised WebP in /public/clients). Own-brand logo and an exact duplicate were excluded.
export const clientLogos = [
  { src: "/clients/client-01.webp", name: "Diamond jewellery brand", w: 201, h: 160 },
  { src: "/clients/client-02.webp", name: "Georgina's Kitchen", w: 160, h: 160 },
  { src: "/clients/client-03.webp", name: "Cleaning Services", w: 320, h: 134 },
  { src: "/clients/client-04.webp", name: "Melbourne Carport Builders", w: 289, h: 160 },
  { src: "/clients/client-05.webp", name: "Eco Systems Homes Kit & Designs", w: 232, h: 160 },
  { src: "/clients/client-06.webp", name: "LVP Wholesale", w: 156, h: 160 },
  { src: "/clients/client-07.webp", name: "GLM Great Learning Minds", w: 275, h: 160 },
  { src: "/clients/client-08.webp", name: "Creative Consulting", w: 159, h: 160 },
  { src: "/clients/client-09.webp", name: "Doors N Windows", w: 306, h: 160 },
  { src: "/clients/client-10.webp", name: "Dhakad Paint Station", w: 244, h: 160 },
  { src: "/clients/client-11.webp", name: "Dhakad Enterprises", w: 320, h: 99 },
  { src: "/clients/client-12.webp", name: "Sakshi Farm", w: 160, h: 160 },
  { src: "/clients/client-13.webp", name: "B.E. Hemp India", w: 160, h: 160 },
  { src: "/clients/client-14.webp", name: "TrustCapital Global Technologies", w: 320, h: 102 },
  { src: "/clients/client-15.webp", name: "Adhiraj eStore", w: 230, h: 160 },
  { src: "/clients/client-16.webp", name: "Sha Foods", w: 320, h: 126 },
  { src: "/clients/client-17.webp", name: "Dr. Ram Manohar Lohia institute", w: 160, h: 160 },
  { src: "/clients/client-18.webp", name: "Pointmark Interiors", w: 320, h: 95 },
  { src: "/clients/client-19.webp", name: "WayXpress", w: 320, h: 135 },
  { src: "/clients/client-20.webp", name: "RS Grand Events and Decorations", w: 153, h: 160 },
  { src: "/clients/client-21.webp", name: "Dhakad Traders", w: 270, h: 160 },
  { src: "/clients/client-22.webp", name: "Cure By Design", w: 166, h: 160 },
  { src: "/clients/client-23.webp", name: "Manya Matrimony", w: 320, h: 114 },
  { src: "/clients/client-24.webp", name: "RCC Foundation", w: 281, h: 160 },
  { src: "/clients/client-25.webp", name: "Osmstays", w: 320, h: 67 },
  { src: "/clients/client-26.webp", name: "Star brand", w: 155, h: 160 },
  { src: "/clients/client-27.webp", name: "Lending Square Group", w: 135, h: 160 },
  { src: "/clients/client-28.webp", name: "Masterkey Locksmith", w: 264, h: 160 },
  { src: "/clients/client-29.webp", name: "Mayrake", w: 320, h: 75 },
  { src: "/clients/client-30.webp", name: "MenoCore", w: 257, h: 160 },
  { src: "/clients/client-31.webp", name: "Parda Sansar", w: 320, h: 68 },
  { src: "/clients/client-32.webp", name: "Samurai Awards", w: 320, h: 32 },
  { src: "/clients/client-33.webp", name: "Dhakad Traders", w: 160, h: 160 },
  { src: "/clients/client-34.webp", name: "Gati Royal Packers & Movers", w: 160, h: 160 },
  { src: "/clients/client-35.webp", name: "Mobile Savvy", w: 311, h: 160 },
  { src: "/clients/client-36.webp", name: "Leaf brand", w: 160, h: 160 },
  { src: "/clients/client-37.webp", name: "C&C Moments", w: 160, h: 160 },
  { src: "/clients/client-38.webp", name: "Mapvanta", w: 320, h: 63 },
];
